import { billingExportPath } from './constants';
import { baseAutomationUrl } from 'src/config';
import { getAccessToken, getRealmName } from 'src/routes/AuthContext';
import { TBillingBatchRetrieveParams } from './types';
import axios from 'axios';
import { getClientIpHeader } from 'src/services/clientIpService/getClientIp';

/**
 * Batch status for a facility-month. A 404 means the export has not been generated yet rather than
 * a failure, so callers should treat it as an absent export.
 */
export const getBillingBatchRetrieve = async (params: TBillingBatchRetrieveParams) => {
  const token = await getAccessToken();
  const realm = getRealmName() ?? '';
  const getFacilityUuid = localStorage.getItem('facilityId');

  if (getFacilityUuid && getFacilityUuid.length) {
    params.facility_uuid = getFacilityUuid;
  }

  params.enterprise_name = realm;

  const url = `${baseAutomationUrl}${billingExportPath.RETRIEVE_BATCH}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      ...(await getClientIpHeader()),
    },
    params: { ...params, batch_type: 'BILLING' },
  });
};
